// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__input-wrapper-LoMxDO, .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__input-wrapper-LoMxDO span {
  width: 100%;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__error-wrapper-w1aOxa .semi-input-wrapper {
  border: 1px solid #ddd;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__error-content-tu8UMi {
  height: 20px;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__error-float-hdNho0 {
  width: 100%;
  position: absolute;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__error-text-TauGQ_ {
  color: #ddd;
  padding-top: 2px;
  padding-left: 12px;
  font-size: 12px;
  position: absolute;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__textarea-pd-P08Qos, .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__inputting-HcW7hV textarea {
  padding-bottom: 0;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__input-blur-wE0bFB textarea {
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  padding-bottom: 0;
  display: -webkit-box;
  overflow: hidden;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input-wrapper": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__input-wrapper-LoMxDO`,
	"inputWrapper": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__input-wrapper-LoMxDO`,
	"error-wrapper": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__error-wrapper-w1aOxa`,
	"errorWrapper": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__error-wrapper-w1aOxa`,
	"error-content": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__error-content-tu8UMi`,
	"errorContent": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__error-content-tu8UMi`,
	"error-float": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__error-float-hdNho0`,
	"errorFloat": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__error-float-hdNho0`,
	"error-text": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__error-text-TauGQ_`,
	"errorText": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__error-text-TauGQ_`,
	"textarea-pd": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__textarea-pd-P08Qos`,
	"textareaPd": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__textarea-pd-P08Qos`,
	"inputting": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__inputting-HcW7hV`,
	"input-blur": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__input-blur-wE0bFB`,
	"inputBlur": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-workflow-sl-textarea-index-module__input-blur-wE0bFB`
};
export default ___CSS_LOADER_EXPORT___;
